import React from "react";
import { Lock, Tag } from "lucide-react";

/**
 * Phase 24e · Pricing badge for marketplace assets.
 * - Free  → gray badge
 * - Paid  → primary gradient badge with EUR amount
 * - Owned → success badge with "Owned"
 */
export function AssetPricingBadge({ is_paid, price_eur_cents = 0, owned = false, size = "md" }) {
  const pad = size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-3 py-1 text-xs";
  if (owned) {
    return (
      <span
        data-testid="pricing-badge-owned"
        className={`inline-flex items-center gap-1 rounded-full border border-[var(--color-success)]/40 bg-[var(--color-success)]/10 text-[var(--color-success)] uppercase tracking-widest font-semibold ${pad}`}
      >
        <Lock className="h-3 w-3" /> Owned
      </span>
    );
  }
  if (!is_paid || !price_eur_cents) {
    return (
      <span
        data-testid="pricing-badge-free"
        className={`inline-flex items-center gap-1 rounded-full border border-white/10 bg-white/5 text-text-secondary uppercase tracking-widest ${pad}`}
      >
        Free
      </span>
    );
  }
  const eur = (Number(price_eur_cents) / 100).toFixed(2).replace(".", ",");
  return (
    <span
      data-testid="pricing-badge-paid"
      className={`inline-flex items-center gap-1 rounded-full border border-[var(--color-primary)]/60 bg-gradient-to-r from-[var(--color-primary)]/20 to-[var(--color-secondary)]/20 text-[var(--color-text-main)] font-semibold tabular-nums ${pad}`}
    >
      <Tag className="h-3 w-3 text-[var(--color-secondary)]" /> ${eur}
    </span>
  );
}

export default AssetPricingBadge;
